import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx } from "vue"

import { ItemMessage, LabelSeverity, ItemMessageType } from '@/b2b/shared/api/server-apis';
import AnimateValue from '@/core/ui-components/AnimateValue.vue';
import { computed } from 'vue';
import { useBlockLabels } from '@/shared/content/blocks/helpers/block-labels.plugin';


export default /*#__PURE__*/_defineComponent({
  __name: 'ItemMessages',
  props: {
    messages: { default: undefined },
    type: { default: ItemMessageType.Basket }
  },
  setup(__props: any) {

const props = __props as { messages: ItemMessage[], type: ItemMessageType }




const labels = useBlockLabels();

const isErrorColor = (severity: LabelSeverity): boolean => severity !== LabelSeverity.Information;
const messagesByType = computed<ItemMessage[]>(() => props.messages?.filter(message => message.type === ItemMessageType.Default || message.type === props.type) ?? []);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, {
    name: "o-anim-fade-300",
    mode: "out-in",
    tag: "div"
  }, {
    default: _withCtx(() => [
      (_unref(messagesByType)?.length)
        ? (_openBlock(), _createElementBlock("div", {
            key: _unref(messagesByType).length
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(messagesByType), (msg, index) => {
              return (_openBlock(), _createBlock(AnimateValue, {
                key: msg.label+index,
                value: _ctx.$dictionary.formatNamed(_unref(labels)[msg.label], msg.namedParams),
                class: _normalizeClass(["block", { 'text-roman': isErrorColor(msg.severity) }]),
                role: "status"
              }, null, 8, ["value", "class"]))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})